import { createSelector } from '@reduxjs/toolkit'
import { Environment } from 'environment.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { useSelector } from 'react-redux'

export const useGetOpenRequests = () => {
  return useSelector(getOpenRequests)
}

const selectOpenRequests = (state: typeof State) =>
  Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development' ? [] : state[orderSlice.name].openRequests
export const getOpenRequests = createSelector(selectOpenRequests, (openRequests) => Object.values(openRequests))
